import { render, staticRenderFns } from "./nextYearCompetition.vue?vue&type=template&id=b172fe44&"
import script from "./nextYearCompetition.vue?vue&type=script&lang=js&"
export * from "./nextYearCompetition.vue?vue&type=script&lang=js&"
import style0 from "./nextYearCompetition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports